import type { ReactNode } from "react";
import { Footer } from "./Footer";
import { Header } from "./Header";

export const AppShell = ({ children }: { children: ReactNode }) => (
  <div className="min-h-screen">
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:left-6 focus:top-6 focus:z-50 focus:rounded-full focus:bg-white focus:px-4 focus:py-2"
    >
      Skip to main content
    </a>
    <Header />
    <main id="main-content">{children}</main>
    <Footer />
  </div>
);
